module.exports = __webpack_public_path__ + "img/construcChange.0b8937c2.png";